// TabGroup.jsx
import React from "react";
import { usePermission } from "../../common/checkPermission";

const tabs = [
  // { label: "Project", module: "Project" },
  { label: "Vendor Grade", module: "Vendor Grade" },
  { label: "Product Group", module: "Product Group" },
  { label: "Category", module: "Category" },
  { label: "Industry", module: "Industry" },
  { label: "Sub Industry", module: "Sub Industry" },
  { label: "Project Stage", module: "Project Stage" },
  { label: "Vendor Stage", module: "Vendor Stage" },
  { label: "Payment Type", module: "Payment Type" },
  { label: "Banks", module: "Bank" },
  { label: "Approval Configuration", module: "Approval Configuration" },
];

export const TabGroup = ({ currentFile, onTabChange }) => {
  const { checkPermission } = usePermission();
  // Show only tabs where the user has "view_permission"
  const visibleTabs = tabs.filter((tab) =>
    tab.label === "Banks" ||
    tab.label === "Approval Configuration" ||
    checkPermission(tab.module, "menu_permission"),
  );

  return (
    <div className="scrollable-tabs">
      {visibleTabs.map((tab) => (
        <button
          key={tab.label}
          onClick={() => onTabChange(tab.label)}
          className={`setup-tab-btn ${currentFile === tab.label ? "textPurple active" : ""}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
